import React, { Component } from 'react'
import DashboardContainer from 'containers/DashboardContainer'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { fetchSignUp, list_update } from 'src/actions/timepoll'
import { signUpDetailSelector } from 'src/selectors'
import { fetchEventById, fetchEventByDraftAndMe } from 'src/actions'
import { parseEventUrl } from 'services/url_helpers'
import { routerActions } from 'react-router-redux'

import TextInputElement from 'components/forms/TextInputElement'
import TextAreaElement from 'components/common/ResizeableTextarea'
import Switch from 'react-switch'
import Button from 'src/components/common/Button'
import SettingWrapper from '../SettingWrapper/SettingWrapper'
import SecondStep from '../SecondStep/SecondStep'
import HobnobModal from 'components/common/HobnobModal'
import EventList from '../FirstStep/EventList/EventList'

import LabelIcon from 'assets/icons/label-icon.png'
import BalloonIcon from 'assets/icons/balloon-icon.png'
import CloseIcon from 'assets/icons/close-icon-bg.png'
import StrokeIcon from 'assets/icons/stroke-icon.png'
import NotesIcon from 'assets/icons/notes-icon.png'
import RemoveIconGray from 'assets/icons/remove-icon-gray.png'
import addIconChecked from 'assets/icons/add-icon-checked.png'
import minusIconChecked from 'assets/icons/minus-icon-checked.png'
import AddIconTheme from 'assets/icons/add-icon-theme.png'
import SettingIcon from 'assets/icons/setting-icon.png'
import PreviewImageIcon from 'assets/icons/preview-image-icon.png'
import BackIcon from 'assets/icons/back-icon.png'
import BackButton from 'assets/icons/back_button.png'

import cn from 'classnames'
import styles from './edit-sign-up.scss'

class EditSignUp extends Component {
  state = {
    isOpenSetting: false,
    isOpenQuantity: true,
    isOpenEventModal: false,
    isOpenImageModal: false,
    eventName: null,
    imageUrl: '',
    signUpEditForm: {
      notes: '',
      email_require: false
    },
    list_options_params: [],
    eventList: [],
    invitationToken: parseEventUrl(window.location.pathname).invitationToken
  }

  fetchSignUpDetail = token => {
    const { onGetSignUpDetails, onGetEventDetails } = this.props
    onGetSignUpDetails({
      token,
      onSuccessCallback: res => {
        const signUpDetail = res.data.list_via_token
        if (signUpDetail?.event_id) {
          onGetEventDetails({
            ids: [signUpDetail.event_id],
            onSuccessCallback: data => {
              this.setState({ eventName: data.data.events[0].name })
            }
          })
        }
        const signUpEditForm = {
          id: signUpDetail.id,
          email_require: signUpDetail.email_require,
          name: signUpDetail.name,
          custom_creator_name: signUpDetail.custom_creator_name,
          created_at: signUpDetail.created_at,
          notes: signUpDetail.notes,
          event_id: signUpDetail.event_id,
          image_upload_id: signUpDetail.image_upload.id,
          ends_at: signUpDetail.ends_at
        }
        this.setState({
          imageUrl: signUpDetail.image_upload.image_url,
          signUpEditForm,
          list_options_params: [...signUpDetail.poll_options]
        })
      }
    })
  }

  getSignUpForm = () => {
    const { signUpForm, goBack } = this.props
    if (!signUpForm.checkedImage) {
      goBack()
      return
    }

    const signUpEditForm = {
      email_require: signUpForm.email_require,
      name: signUpForm.name,
      custom_creator_name: signUpForm.custom_creator_name,
      notes: signUpForm.notes,
      event_id: signUpForm.checkedEvent?.id,
      image_upload_id: signUpForm.image_upload_id,
      poll_type: 'item',
      ends_at: signUpForm.ends_at
    }
    this.setState({
      eventName: signUpForm.checkedEvent?.name,
      imageUrl: signUpForm.checkedImage.url,
      signUpEditForm,
      list_options_params: signUpForm.list_options_params
    })
  }

  componentDidMount() {
    if (this.state.invitationToken) {
      this.fetchSignUpDetail(this.state.invitationToken)
    } else {
      this.getSignUpForm()
    }

    // initial data
    this.props.getEventList({
      onSuccessCallback: data => {
        this.setState({ eventList: data.data.me?.events_connection.events })
      }
    })
  }

  _handleChange = (type, value) => {
    const { signUpEditForm } = this.state
    if (type === 'ends_at' && !value) {
      delete signUpEditForm.ends_at
      this.setState({ signUpEditForm })
      return
    }

    if (type === 'event') {
      this.setState({
        signUpEditForm: { ...signUpEditForm, event_id: value === 'remove' ? '' : value.id },
        eventName: value === 'remove' ? '' : value.name
      })
      return
    }

    if (type === 'image') {
      this.setState({
        signUpEditForm: { ...signUpEditForm, image_upload_id: value.id },
        imageUrl: value.url
      })
      return
    }
    this.setState({ signUpEditForm: { ...signUpEditForm, [type]: value } })
  }

  _handleChangeOption = params => {
    const { value, type, index } = params

    const { list_options_params } = this.state
    switch (type) {
      case 'item':
        list_options_params[index] = { ...list_options_params[index], item: value }
        break
      case 'count_limit':
        list_options_params[index] = { ...list_options_params[index], count_limit: value }
        break
      case 'description':
        list_options_params[index] = { ...list_options_params[index], description: value }
        break
    }

    this.setState({ list_options_params })
  }

  handleChangeCount = (type, item, index) => {
    let count = item.count_limit === 9999 ? 0 : item.count_limit

    if (type === 'add') {
      if (count >= 50) {
        return
      }
      count += 1
    }

    if (type === 'minus') {
      if (count <= 0) {
        return
      }
      count -= 1

      if (count === 0) {
        count = 9999
      }
    }

    this._handleChangeOption({ value: count, type: 'count_limit', index })
  }

  _addOption = () => {
    const initialOption = {
      item: '',
      item_rank: 0,
      count_limit: 9999,
      description: ''
    }
    const { list_options_params } = this.state
    list_options_params.push({ ...initialOption, item_rank: list_options_params.length })
    this.setState({ list_options_params })
  }

  _removeOption = index => {
    let { list_options_params } = this.state
    list_options_params.splice(index, 1)

    list_options_params = list_options_params.map((item, index) => ({ ...item, item_rank: index }))
    this.setState({ list_options_params })
  }

  handleSubmit = () => {
    const { signUpEditForm, invitationToken } = this.state
    const { onSignUpFormSubmit, goBack, goSignUpDetail } = this.props

    const list_params = {
      id: signUpEditForm.id,
      email_require: signUpEditForm.email_require,
      name: signUpEditForm.name,
      custom_creator_name: signUpEditForm.custom_creator_name,
      notes: signUpEditForm.notes,
      event_id: signUpEditForm.event_id,
      image_upload_id: signUpEditForm.image_upload_id,
      poll_type: 'item',
      ends_at: signUpEditForm.ends_at
    }

    const list_options_params = this.state.list_options_params.map(item => ({
      id: item.id,
      count_limit: item.count_limit,
      description: item.description,
      item: item.item,
      item_rank: item.item_rank
    }))

    onSignUpFormSubmit({
      list_params,
      list_options_params,
      onSuccessCallback: data => {
        if (data.data.list_update.successful) {
          if (invitationToken) {
            goBack()
          } else {
            goSignUpDetail(data.data.list_update.result.token)
            sessionStorage.removeItem('signUpForm')
          }
        }
      },
      onFailCallback: data => {
        if (!data.data.list_update.successful) {
          alert(data.data.list_update.messages[0])
        }
      }
    })
  }

  render() {
    const {
      imageUrl,
      signUpEditForm,
      list_options_params,
      eventName,
      isOpenSetting,
      isOpenQuantity,
      isOpenEventModal,
      eventList,
      isOpenImageModal
    } = this.state
    const { goBack } = this.props
    return (
      <DashboardContainer>
        <div className={styles['container']}>
          <div className={styles['edit-sign-up-nav']}>
            <img src={BackButton} onClick={goBack} width="18" />
            <span>edit lists</span>
            <img
              src={SettingIcon}
              onClick={() => this.setState({ isOpenSetting: true })}
              width="18"
            />
          </div>
          <div
            className={cn(styles['edit-sign-up-container'], {
              [styles['overflow-y-hidden']]: isOpenSetting
            })}
          >
            <div className={styles['edit-sign-up-left']}>
              <div className={styles['sign-up-image-wrapper']}>
                <img
                  className={cn(styles['sign-up-image'], styles['cursor-pointer'])}
                  src={imageUrl}
                />
                <img
                  src={PreviewImageIcon}
                  onClick={() => this.setState({ isOpenImageModal: true })}
                  className={cn(styles['preview-icon'], styles['cursor-pointer'])}
                  width="40"
                />
                
                <img src={BackIcon} onClick={goBack} className={styles['back-icon']} width="40" />
              </div>
              <div className={styles['sign-up-info']}>
                <div className={styles['input-wrapper']}>
                  <img src={LabelIcon} alt="" width="18" />
                  <TextInputElement
                    className={styles['input-inner']}
                    placeholder="Name Your Sign Up List"
                    onChange={event => this._handleChange('name', event.target.value)}
                    valid
                    value={signUpEditForm.name}
                  />
                </div>

                <div className={styles['information-label']}>optional</div>

                <div className={styles['input-wrapper']}>
                  <img src={BalloonIcon} alt="" width="20" />
                  <TextInputElement
                    onClick={() => this.setState({ isOpenEventModal: true })}
                    className={styles['input-inner']}
                    placeholder="Event"
                    onChange={() => {}}
                    valid
                    value={eventName}
                    readOnly
                  />
                  <img
                    src={CloseIcon}
                    width="20"
                    style={{ cursor: 'pointer' }}
                    onClick={() => this._handleChange('event', 'remove')}
                  />
                </div>

                <div className={styles['input-wrapper']}>
                  <img src={StrokeIcon} alt="" width="20" />
                  <TextInputElement
                    className={styles['input-inner']}
                    placeholder="Custom Creator Name"
                    valid
                    value={signUpEditForm.custom_creator_name}
                    onChange={event =>
                      this._handleChange('custom_creator_name', event.target.value)
                    }
                  />
                </div>

                <div className={cn(styles['input-wrapper'], styles['textArea-wrapper'])}>
                  <img src={NotesIcon} alt="" width="22" />
                  <TextAreaElement
                    className={styles['textArea-inner']}
                    placeholder="Notes"
                    onChangeComment={value => this._handleChange('notes', value)}
                    comment={signUpEditForm.notes || ''}
                  />
                </div>
              </div>
            </div>
            <div className={styles['edit-sign-up-right']}>
              
              <div className={styles['edit-sign-up-header']}>
                <div className={styles['header-label']}>slot/item</div>
                <div className={styles['switch-wrapper']}>
                  <label>select quantity</label>
                  <Switch
                    onChange={checked => this.setState({ isOpenQuantity: checked })}
                    checked={isOpenQuantity}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2cd4ae"
                    width={40}
                    height={20}
                  />
                </div>
                <img
                  src={SettingIcon}
                  onClick={() => this.setState({ isOpenSetting: true })}
                  className={cn(styles['cursor-pointer'], styles['setting-icon'])}
                  width="20"
                />
              </div>
              <div className={styles['edit-sign-up-list']}>
                <ul className={styles['edit-sign-up-ul']}>
                  {list_options_params.map((item, index) => (
                    <li className={styles['edit-sign-up-li']} key={index}>
                      <div className={styles['item-information']}>
                        <img
                          src={RemoveIconGray}
                          onClick={() => this._removeOption(index)}
                          width="18"
                          className={styles['cursor-pointer']}
                        />
                        <TextInputElement
                          className={styles['input-inner']}
                          placeholder="Input Slot/Item"
                          onChange={event =>
                            this._handleChangeOption({
                              value: event.target.value,
                              type: 'item',
                              index
                            })
                          }
                          valid
                          value={item.item}
                        />
                        {isOpenQuantity && (
                          <div className={styles['button-wrapper']}>
                            <div
                              className={styles['icon-wrapper']}
                              onClick={() => this.handleChangeCount('minus', item, index)}
                            >
                              <img src={minusIconChecked} width="10" />
                            </div>
                            <div className={styles['count-wrapper']}>
                              {item.count_limit === 9999 ? 0 : item.count_limit}
                            </div>
                            <div
                              className={styles['icon-wrapper']}
                              onClick={() => this.handleChangeCount('add', item, index)}
                            >
                              <img src={addIconChecked} width="10" />
                            </div>
                          </div>
                        )}
                      </div>

                      <div className={styles['item-line']} />

                      <div className={styles['item-notes']}>
                        <TextAreaElement
                          className={styles['textArea-inner']}
                          placeholder="Notes"
                          onChangeComment={value =>
                            this._handleChangeOption({ value: value, type: 'description', index })
                          }
                          comment={item.description || ''}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className={styles['add-item-wrapper']} onClick={this._addOption}>
                <img src={AddIconTheme} width="18" />
                <span>add</span>
              </div>
              <div className={styles['edit-sign-up-button']}>
                <Button className={styles['button']} onClick={this.handleSubmit}>
                  save change
                </Button>
              </div>
            </div>
          </div>
          {isOpenSetting && (
            <div className={styles['setting-wrapper']}>
              <SettingWrapper
                signUpEditForm={signUpEditForm}
                type="edit"
                onChange={params => this._handleChange(params.type, params.value)}
                onClose={() => this.setState({ isOpenSetting: false })}
              />
            </div>
          )}
        </div>

        <HobnobModal
          show={isOpenEventModal}
          onClose={() => this.setState({ isOpenEventModal: false })}
        >
          <EventList
            onClose={() => this.setState({ isOpenEventModal: false })}
            eventList={eventList}
            type="edit"
            onChange={params => this._handleChange(params.type, params.value)}
          />
        </HobnobModal>

        <HobnobModal
          show={isOpenImageModal}
          onClose={() => this.setState({ isOpenImageModal: false })}
          containerStyles={{ maxWidth: '90vw', height: '80vh' }}
        >
          <SecondStep
            onChange={params => this._handleChange(params.type, params.value)}
            onClose={() => this.setState({ isOpenImageModal: false })}
            type="edit"
          />
        </HobnobModal>
      </DashboardContainer>
    )
  }
}

EditSignUp.propTypes = {
  onGetSignUpDetails: PropTypes.func,
  onGetEventDetails: PropTypes.func,
  goBack: PropTypes.func,
  getEventList: PropTypes.func,
  onSignUpFormSubmit: PropTypes.func,
  signUpForm: PropTypes.object,
  goSignUpDetail: PropTypes.func
}

function mapStateToProps(state) {
  return {
    signUpDetail: signUpDetailSelector(state),
    signUpForm: state.frontend.signUpForm
  }
}
function mapDispatchToProps(dispatch) {
  return {
    onGetSignUpDetails: params => dispatch(fetchSignUp(params)),
    onGetEventDetails: params => dispatch(fetchEventById(params)),
    goBack: () => dispatch(routerActions.goBack()),
    getEventList: params => dispatch(fetchEventByDraftAndMe(params)),
    onSignUpFormSubmit: params => dispatch(list_update(params)),
    goSignUpDetail: token => dispatch(routerActions.push('/su/' + token))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSignUp)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/SignUp/CreateSignUp/EditSignUp/EditSignUp.jsx